import { merge } from 'lodash-es'
import actions from './actions'

const state = {
  lastSelectThread: null,
  showThreadTools: false,
  threadToolOperations: '',
}

const getters = {
  lastSelectThread(state) {
    return state.lastSelectThread
  },
  showThreadTools(state) {
    return state.showThreadTools
  },
}

const mutations = {
  setLastSelectThread(state, data = null) {
    state.lastSelectThread = data
  },
  setThreadTools(state, data = {}) {
    state.showThreadTools = data.show || false
    state.threadToolOperations = data.operations || ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
